import { ref, computed } from 'vue'
import movimientosServicio from '@/services/finanzas/movimientosServicio'
import categoriasServicio from '@/services/finanzas/categoriasServicio'
import cuentasBancariasServicio from '@/services/finanzas/cuentasBancariasServicio'
import Swal from 'sweetalert2'

export function useMovimientos() {
  const movimientos = ref([])
  const categorias = ref([])
  const cuentas = ref([])
  const cargando = ref(false)
  const filtros = ref({
    tipo: null,
    cuenta_bancaria_id: null,
    categoria_id: null,
    fecha_inicio: null,
    fecha_fin: null
  })

  const movimientosIngresos = computed(() => 
    movimientos.value.filter(m => m.tipo === 'ingreso')
  )

  const movimientosEgresos = computed(() => 
    movimientos.value.filter(m => m.tipo === 'gasto')
  )

  const cargarMovimientos = async (params = {}) => {
    cargando.value = true
    try {
      const respuesta = await movimientosServicio.listar({ ...filtros.value, ...params })
      movimientos.value = respuesta.data || respuesta
    } catch (error) {
      Swal.fire('Error', 'No se pudieron cargar los movimientos', 'error')
    } finally {
      cargando.value = false
    }
  }

  const cargarCategorias = async (tipo = null) => {
    try {
      const params = tipo ? { tipo, solo_activas: true } : { solo_activas: true }
      categorias.value = await categoriasServicio.listar(params)
    } catch (error) {
      console.error('Error al cargar categorías:', error)
    }
  }

  const cargarCuentas = async () => {
    try {
      cuentas.value = await cuentasBancariasServicio.listar()
    } catch (error) {
      console.error('Error al cargar cuentas:', error)
    }
  }

  const crearMovimiento = async (datos) => {
    cargando.value = true
    try {
      await movimientosServicio.crear(datos)
      await Swal.fire('Éxito', 'Movimiento registrado correctamente', 'success')
      await cargarMovimientos()
    } catch (error) {
      Swal.fire('Error', error.mensaje || 'No se pudo crear el movimiento', 'error')
      throw error
    } finally {
      cargando.value = false
    }
  }

  const eliminarMovimiento = async (id) => {
    const result = await Swal.fire({
      title: '¿Eliminar movimiento?',
      text: 'Esta acción revertirá el saldo de la cuenta',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    })

    if (result.isConfirmed) {
      try {
        await movimientosServicio.eliminar(id)
        await Swal.fire('Eliminado', 'Movimiento eliminado correctamente', 'success')
        await cargarMovimientos()
      } catch (error) {
        Swal.fire('Error', 'No se pudo eliminar el movimiento', 'error')
      }
    }
  }

  return {
    movimientos,
    movimientosIngresos,
    movimientosEgresos,
    categorias,
    cuentas,
    cargando,
    filtros,
    cargarMovimientos,
    cargarCategorias,
    cargarCuentas,
    crearMovimiento,
    eliminarMovimiento
  }
}
